/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tier: NonNullable<unknown>, targetTier: NonNullable<unknown> }} Trialupgradewarning2Inputs */

const en_trialupgradewarning2 = /** @type {(inputs: Trialupgradewarning2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This will end your active ${i?.tier} trial immediately and start a paid ${i?.targetTier} subscription.`)
};

const de_trialupgradewarning2 = /** @type {(inputs: Trialupgradewarning2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dies beendet dein aktives ${i?.tier}-Testabo sofort und startet ein kostenpflichtiges ${i?.targetTier}-Abonnement.`)
};

/**
* | output |
* | --- |
* | "This will end your active {tier} trial immediately and start a paid {targetTier} subscription." |
*
* @param {Trialupgradewarning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trialupgradewarning2 = /** @type {((inputs: Trialupgradewarning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trialupgradewarning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trialupgradewarning2(inputs)
	return de_trialupgradewarning2(inputs)
});
export { trialupgradewarning2 as "trialUpgradeWarning" }